import { isPossiblePhoneNumber } from '@branch-messenger/willow-ui'
import * as yup from 'yup'

export const phoneNumberFormSchema = yup.object().shape({
  phoneNumber: yup
    .string()
    .test({
      name: 'Phone is valid',
      message: 'Please enter a valid phone number',
      test: value => (value ? isPossiblePhoneNumber(value) : false),
    })
    .required(),
})

export type PhoneNumberFormSchema = yup.InferType<typeof phoneNumberFormSchema>
